// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/empty.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*fade*/
.cdsp_dashboard .fade-enter-active,
.cdsp_dashboard .fade-leave-active {
  transition: opacity 0.28s;
}
.cdsp_dashboard .fade-enter,
.cdsp_dashboard .fade-leave-active {
  opacity: 0;
}
/*fade*/
.cdsp_dashboard .breadcrumb-enter-active,
.cdsp_dashboard .breadcrumb-leave-active {
  transition: all 0.5s;
}
.cdsp_dashboard .breadcrumb-enter,
.cdsp_dashboard .breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}
.cdsp_dashboard .breadcrumb-move {
  transition: all 0.5s;
}
.cdsp_dashboard .breadcrumb-leave-active {
  position: absolute;
}
html,
body {
  padding: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 12px;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  color: var(--color-text-primary);
}
*,
*:before,
*:after {
  box-sizing: border-box;
}
.orange-project .iconfont {
  font-size: 20px;
}
.must-input-color {
  color: #ff4141;
}
.color1 {
  color: var(--color-primary);
}
.primary-color {
  color: var(--color-primary);
}
.error-color {
  color: var(--color-danger);
}
.warning-color {
  color: var(--color-warning);
}
.content-color {
  color: var(--color-text-primary);
}
.secondary-color {
  color: var(--color-text-secondary);
}
.regular-color {
  color: var(--color-text-regular);
}
.tip-color {
  color: var(--text-color-level3);
}
.ml-12px {
  margin-left: 12px;
}
.mb-12px {
  margin-bottom: 12px;
}
.mb-36px {
  margin-bottom: 36px;
}
.mt-24px {
  margin-bottom: 24px;
}
.mb-6px {
  margin-bottom: 6px;
}
.el-icon-question-helper {
  color: var(--color-primary);
  margin-left: 2px;
  font-size: 14px;
}
.el-dialog__body {
  padding: 16px 20px 20px 20px;
  border-top: 1px solid var(--line-color-level1);
  border-bottom: 1px solid var(--line-color-level1);
  max-height: 497px;
  overflow: auto;
}
.el-dialog__wrapper[fullscreen='true'] .el-dialog__body {
  max-height: none;
}
/**
 * 弹窗样式，封装的layer的弹窗
 **/
body .layer-dialog .layui-layer-title {
  border-radius: 4px 4px 0px 0px;
  border: 1px solid #01000000;
}
body .layer-dialog .layui-layer-setwin {
  color: #fff;
}
body .layer-dialog {
  border-radius: 4px;
  border: 1px solid #01000000;
}
body .layer-dialog .layui-layer-content {
  padding: 25px;
}
/**
 * 左树右表弹窗样式
 */
body .layer-advance-dialog {
  border-radius: 4px;
  border: 1px solid #01000000;
  background-color: #f8f8f8;
}
body .layer-advance-dialog .layui-layer-title {
  border-radius: 4px 4px 0px 0px;
  border: 1px solid #01000000;
}
body .layer-advance-dialog .layui-layer-content {
  padding: 5px 15px;
}
.orange-project {
  overflow: hidden;
}
.el-main {
  padding: 16px;
}
.flex-box {
  flex-wrap: wrap;
}
.scrollbar_dropdown__wrap {
  overflow-x: hidden;
}
.icon-btn.el-button {
  font-size: 18px;
  padding: 5px 0px;
}
.default-padding-box {
  padding: 25px;
}
.padding-no-top {
  padding: 0px 25px 25px 25px;
}
.default-border {
  border: 1px solid var(--border-color-base);
}
.default-border-left {
  border-left: 1px solid var(--border-color-base);
}
.default-border-right {
  border-right: 1px solid var(--border-color-base);
}
.default-border-top {
  border-top: 1px solid var(--border-color-base);
}
.default-border-bottom {
  border-bottom: 1px solid var(--border-color-base);
}
.page-close-box {
  position: absolute;
  background: #0092ff;
  transform: rotate(45deg);
  height: 50px;
  width: 50px;
  right: -25px;
  top: -25px;
  text-align: center;
}
.page-close-box .el-button {
  transform: rotate(-45deg);
  color: white;
  margin-top: 20px;
}
.el-button + .btn-import {
  margin-left: 10px !important;
}
.dashboard-designer .el-button--primary {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: #fff;
}
.dashboard-designer .el-button--primary.is-disabled,
.dashboard-designer .el-button--primary.is-disabled:hover,
.dashboard-designer .el-button--primary.is-disabled:focus,
.dashboard-designer .el-button--primary.is-disabled:active {
  border-color: #bad7ff;
  background: #bad7ff;
}
.dashboard-designer .el-button--text {
  color: var(--color-primary);
}
.dashboard-designer .el-button.is-disabled.el-button--text {
  color: var(--disabled-primary-color);
}
.dashboard-designer .el-button--primary.is-plain {
  color: var(--color-primary);
  background: #ecf5ff;
  border-color: #b3d8ff;
}
.dashboard-designer .textarea-disabled-resize textarea {
  resize: none;
}
.dashboard-designer .is-process .el-step__icon.is-text {
  border-color: var(--color-primary);
  color: #fff;
  background-color: var(--color-primary);
}
/**
 * 过滤组件样式
 **/
.mask-box {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  z-index: 10;
}
.filter-box {
  position: relative;
  background-color: white;
  padding: 25px 25px 0px 25px;
  z-index: 20;
}
.advance-filter-box {
  padding-bottom: 25px;
}
.filter-item {
  width: 250px;
}
.cascader-item {
  width: 160px !important;
}
.is-range,
.is-search {
  width: 400px;
}
.table-operation-box {
  align-self: flex-end;
  margin-bottom: 10px;
  overflow: hidden;
}
.table-check-box {
  margin-right: 7px;
}
/**
 * 左侧树状组件的样式，用户高级管理表单以及用户管理表单
 **/
.advanced-left-box {
  border-right: 1px solid #d8dce5;
}
.advanced-left-box .el-tree-node__content {
  height: 40px;
}
.advanced-left-box .tree-node-item {
  height: 40px;
  line-height: 40px;
  width: 100%;
}
.advanced-left-box .tree-node-item .tree-node-menu {
  display: none;
  float: right;
  padding-right: 10px;
  color: var(--color-danger) !important;
}
.advanced-left-box .tree-node-item:hover .tree-node-menu {
  display: block;
}
.advanced-left-box .el-tree-node .el-button + .el-button {
  margin-left: 5px;
}
/**
 * form表单输入组件宽度
 **/
.full-width-input .el-select {
  width: 100%;
}
.full-width-input .el-input {
  width: 100%;
}
.full-width-input .el-cascader {
  width: 100%;
}
.full-width-input .el-date-editor {
  width: 100%;
}
.full-width-input .el-input-number {
  width: 100%;
}
.el-form-item.el-form-item--mini {
  min-height: 29px;
}
.el-form-item.el-form-item--small {
  min-height: 32px;
}
.el-form-item.el-form-item--medium {
  min-height: 36px;
}
.el-form-item.el-form-item--default {
  min-height: 40px;
}
.el-aside {
  overflow: visible;
}
.el-menu {
  border-right-width: 0px;
}
.sidebar-title {
  display: flex;
  align-items: center;
  height: 58px;
  padding-left: 20px;
  white-space: nowrap;
}
.sidebar-title-text {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #262626;
  padding-left: 8px;
}
/**
 * 多tab页表单，tab样式
 **/
.dashboard-designer .el-tabs__header {
  margin: 8px 0 16px;
}
/**
 * 表格表头背景色
 **/
.table-header-gray,
.has-gutter .gutter {
  background-color: #ebeef5;
}
.table-header-gray th.el-table__cell {
  background-color: #f7f8fa !important;
}
/**
 * 操作按钮颜色
 **/
.table-btn.delete {
  color: #f56c6c;
}
.table-btn.delete:hover {
  color: #f78989;
}
.table-btn.delete:disabled {
  color: #dcdfe6;
}
.table-btn.success {
  color: #67c23a;
}
.table-btn.success:hover {
  color: #85ce61;
}
.table-btn.success:disabled {
  color: #dcdfe6;
}
.table-btn.warning {
  color: #e6a23c;
}
.table-btn.warning:hover {
  color: #ebb563;
}
.table-btn.success:disabled {
  color: #dcdfe6;
}
.el-table--group::after,
.el-table--border::after {
  width: 0px;
}
/**
 * 图片上传以及显示样式
 **/
.upload-image-item {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 65px;
  text-align: center;
  display: block;
}
.upload-image-item .el-upload i {
  line-height: 65px;
}
.upload-image-multi {
  display: inline;
}
.upload-image-item .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.upload-image-item .el-upload:hover {
  border-color: var(bi-jz-primary-color);
}
.upload-image-show {
  width: 65px;
  height: 65px;
  display: inline;
}
.table-cell-image {
  width: 65px;
  height: 65px;
  line-height: 65px;
  text-align: center;
  font-size: 65px;
  color: #606266;
  margin: 0px 5px;
}
.upload-image-list .el-upload-list__item {
  width: 65px;
  height: 65px;
  line-height: 65px;
}
.upload-image-item .el-upload-list--picture-card .el-upload-list__item {
  width: 65px;
  height: 65px;
}
.upload-image-item .el-upload.el-upload--text {
  width: 65px;
  height: 65px;
}
.upload-image-item .el-upload--picture-card {
  width: 65px;
  height: 65px;
  line-height: 65px;
}
/**
 *
 **/
.sidebar {
  height: 100%;
  background-color: var(--color-menu-background);
  box-shadow: 0px 1px 4px rgba(0, 21, 41, 0.08);
}
.header {
  display: flex;
  align-items: center;
  height: 60px;
  background-color: white;
}
.header .menu-column {
  margin-right: 20px;
}
.header .menu-column .el-menu-item.is-active {
  border-left: 0 solid #47ba5a;
}
.header-menu {
  float: right;
  height: 32px;
  line-height: 32px;
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
}
.header-menu .circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ff4141;
  position: absolute;
  right: -3px;
  top: -2px;
}
.header-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-left: 10px;
  float: right;
}
.el-menu--horizontal.el-menu {
  background-color: white;
}
.el-menu--horizontal > .el-menu-item {
  height: 40px;
  line-height: 40px;
  padding: 0;
  margin: 0 20px;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.user-dropdown {
  color: #909399;
  cursor: pointer;
  font-size: 12px;
}
.user-dropdown-item {
  font-size: 12px;
  color: var(--color-primary);
}
.user-dropdown-item .el-badge {
  margin-top: -8px;
  margin-left: 10px;
  height: 20px;
}
.hamburger-container {
  line-height: 70px;
  height: 60px;
  float: left;
  padding: 0 10px;
}
.el-submenu__title {
  background: #00000000;
}
.tree-select .el-tree-node__content {
  height: 34px;
  line-height: 34px;
  padding-right: 10px;
}
.tree-select.single-select-tree .el-tree-node.is-current > .el-tree-node__content > .el-tree-node__label {
  color: var(--color-primary);
  font-weight: 700;
}
.cell .operation-cell {
  color: #006cdc;
  cursor: pointer;
  text-decoration: underline;
}
.single-select-tree {
  min-width: 200px !important;
}
.base-card-header {
  display: flex;
  align-items: center;
  height: 50px;
  line-height: 50px;
}
.base-card-operation {
  display: flex;
  justify-content: flex-end;
}
.base-card-operation .el-button i {
  font-size: 16px !important;
}
.el-card__header {
  margin: 0 var(--block-gap-pro);
  padding: 0;
}
.el-card__body {
  padding: 12px 16px;
}
.custom-cascader {
  width: 200px !important;
}
.no-scroll {
  overflow: hidden;
}
.custom-scroll .el-scrollbar__view {
  overflow-x: hidden !important;
}
.upload-img-del {
  position: absolute;
  height: 20px;
  width: 20px;
  line-height: 20px;
  font-size: 16px;
  top: 2px;
  right: 2px;
  color: #c0c4cc;
}
.upload-img-del:hover {
  color: #ef5e1c;
}
.input-label {
  display: inline-block;
  height: 29px;
  line-height: 28px;
}
.input-progress {
  height: 29px;
  display: flex;
  align-items: center;
}
.input-item {
  width: 100% !important;
}
.table-header-gray {
  background: #fafafa;
}
.table-header-custom {
  background: #f6f9fb;
}
.card-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
  line-height: 28px;
}
.delete-confirm .el-message-box__btns .el-button--primary {
  color: #fff;
  background: #f53f3f;
  border-color: #f53f3f;
}
.multi-text .el-message-box__content .el-message-box__container .el-message-box__status {
  top: 14%;
}
.multi-text-top .el-message-box__content .el-message-box__container .el-message-box__status {
  top: 30%;
}
.multi-text-tip .el-message-box__content .el-message-box__container .el-message-box__status {
  top: 19%;
}
.multi-two-lines-text-tip .el-message-box__content .el-message-box__container .el-message-box__status {
  top: 12px;
}
.display-right {
  margin-left: auto;
}
.filter-item-date {
  width: 330px;
}
.form-online .el-dialog .el-dialog__body {
  max-height: 450px;
  overflow: hidden;
  overflow-y: auto;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: none;
  margin-right: 4px;
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 2px;
}
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.ml20 {
  margin-left: 20px;
}
.mr20 {
  margin-right: 20px;
}
.mt20 {
  margin-top: 20px;
}
.mt12 {
  margin-top: 12px;
}
.mt6 {
  margin-top: 6px;
}
.mb20 {
  margin-bottom: 20px;
}
.pl20 {
  padding-left: 20px;
}
.pr20 {
  padding-right: 20px;
}
.pt20 {
  padding-top: 20px;
}
.pb20 {
  padding-bottom: 20px;
}
.gutter-left {
  padding-left: 20px;
}
.gutter-right {
  padding-right: 20px;
}
.gutter-top {
  padding-top: 20px;
}
.gutter-bottom {
  padding-bottom: 20px;
}
.page_box {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin: -14px -20px 16px -20px;
  height: 50px;
}
.list-header .text {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text-primary);
}
.el-message-box__wrapper .message_box .el-message-box__content .el-message-box__input {
  width: 280px;
  margin: -50px 0 0 100px;
}
.el-table .cell,
.planList .tb-flex .text,
.ty_flex .nameLabel,
.el-table .cell > div:first-child,
.vxe-table--render-wrapper .vxe-cell,
.el-table .cell .el-button--text {
  overflow: hidden;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.el-table .cell img {
  vertical-align: middle;
}
.base-conf-dialog .el-dialog__body {
  max-height: 500px;
  overflow: auto;
}
.el-checkbox__inner {
  border: 1px solid #999;
}
.el-radio__inner {
  border: 1px solid #999;
}
.el-textarea__inner {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}
.stopUsing {
  color: #aaaaaa;
}
.defaultBox {
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  color: #000;
}
.greyBox {
  background: var(--bg-info-color);
  border: 1px solid var(--text-color-level4);
  color: var(--text-color-level4);
}
.greenBox {
  background: var(--success-color-level1);
  border: 1px solid var(--color-success);
  color: var(--color-success);
}
.redBox {
  background: var(--error-color-level1);
  border: 1px solid var(--color-danger);
  color: var(--color-danger);
}
.yellowBox {
  background: var(--warning-color-level1);
  border: 1px solid var(--color-warning);
  color: var(--color-warning);
}
.blueBox {
  background: var(--primary-color-level1);
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
}
.purpleBox {
  background: #F9F0FF;
  border: 1px solid #EDD6FF;
  color: #9D57F2;
}
.tableTagMargin {
  margin-right: 4px;
}
.detail-card {
  margin-bottom: 20px;
}
.detail-card .detail-title {
  position: relative;
  padding-left: 8px;
  font-weight: bold;
  color: #282828;
  font-size: 14px;
  margin-bottom: 16px;
}
.detail-card .detail-title:after {
  position: absolute;
  content: '';
  height: 90%;
  top: 5%;
  left: 0;
  width: 3px;
  background-color: var(--color-primary);
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.self-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.self-table tr {
  height: 40px;
}
.self-table td,
.self-table th {
  border: 1px solid var(--line-color-level1);
  padding: 10px;
  text-align: left;
  color: #262626;
  font-weight: normal;
}
.self-table thead th {
  background: var(--bg-info-color);
}
.center {
  text-align: center !important;
}
.pb60 {
  padding-bottom: 60px !important;
}
.color-common {
  color: var(--color-primary);
}
.dataEl {
  padding: 0 5px;
  background-color: #f0faff;
  border: 1px solid #abdcff;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  width: 100%;
  box-sizing: border-box;
  color: #2e8cf0;
}
.dataEl span {
  max-width: 160px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dataEl .deleteIcon {
  line-height: 30px;
  cursor: pointer;
}
.add-sec {
  width: 100%;
  line-height: 30px;
  color: var(--color-primary);
  background-color: #f9fafc;
  border: 1px solid #ebeef5;
  padding: 5px 20px 5px 30px;
  cursor: pointer;
}
.un-select-control .el-drawer,
.un-select-control * {
  user-select: none;
}
.cursor-pointer {
  cursor: pointer;
}
.number-color {
  color: var(--color-primary);
}
.text_danger {
  color: var(--color-danger);
  font-weight: normal;
  font-size: 12px;
}
.w-100 {
  width: 100%;
}
.el-dialog__wrapper .el-dialog .el-dialog__body .el-form-item--mini .el-form-item {
  margin-right: inherit;
}
.el-popper .el-cascader-node__label {
  max-width: 300px;
}
.height-auto {
  height: 100%;
}
.tableSortHeader {
  display: flex;
}
.tableSortHeader .arrow_box {
  justify-content: center;
  height: 14px;
  width: 14px;
  margin-left: 5px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  overflow: initial;
}
.tableSortHeader .arrow_box .top {
  width: 0;
  height: 0;
  border: 4px solid transparent;
  left: 7px;
  border-bottom-color: #c0c4cc;
  margin-bottom: 3px;
}
.tableSortHeader .arrow_box .top:hover {
  border-bottom-color: var(--color-primary);
}
.tableSortHeader .arrow_box .bottom {
  width: 0;
  height: 0;
  border: 4px solid transparent;
  left: 7px;
  border-top-color: #c0c4cc;
}
.tableSortHeader .arrow_box .bottom:hover {
  border-top-color: var(--color-primary);
}
.isActiveTop {
  border-radius: 2px;
  border-bottom-color: var(--color-primary) !important;
}
.isActiveBottom {
  border-radius: 2px;
  border-top-color: var(--color-primary) !important;
}
.el-step__head.is-success {
  color: var(--color-primary);
  border-color: var(--color-primary);
}
.el-step__description.is-success,
.el-step__title.is-success {
  color: var(--color-primary);
}
.el-loading-mask.is-fullscreen {
  z-index: 3000 !important;
}
.question-icon {
  color: var(--color-primary);
  font-size: 14px;
  cursor: pointer;
}
.common-divider {
  margin: 6px 0;
}
.dashboard-designer .el-table__empty-block {
  position: relative;
  min-height: 164px;
  width: 100% !important;
  border-bottom: 1px solid #ebeef5;
}
.dashboard-designer .el-table__empty-block:before {
  content: '';
  display: block;
  width: 184px;
  height: 102px;
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  top: 20px;
  left: calc(50% - 92px);
}
.dashboard-designer .el-table__empty-block:after {
  position: absolute;
  content: '';
  height: 4px;
  width: 100%;
  bottom: 0;
  background: #fff;
  z-index: 99;
}
.dashboard-designer .el-table__empty-block .el-table__empty-text {
  position: absolute;
  top: 122px;
  line-height: 22px;
  color: var(--text-color-level4);
}
.dashboard-designer .el-empty .el-empty__description {
  margin-top: 0px;
  line-height: 20px;
}
.dashboard-designer .el-empty .el-empty__bottom {
  margin-top: 4px;
  line-height: 20px;
}
*[w-title] {
  position: relative;
}
*[w-title]:after {
  content: attr(w-title);
  position: absolute;
  width: 160px;
  top: 20px;
  left: 0;
  z-index: 9999;
  background: #ffffff;
  padding: 4px 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0px 0px 6px rgba(0, 0, 0, 0.04);
  border-radius: 2px;
}
.sticky-select .el-select-dropdown,
.sticky-select .el-date-picker {
  position: absolute !important;
  top: 30px !important;
  left: 0 !important;
}
.layout-offset-button {
  position: absolute;
  right: 1%;
  transform: translateY(51px);
}
.tabs_box {
  overflow-y: hidden;
}
.cell .table-cell-flex {
  display: flex;
}
.cell .table-cell-flex > div:first-child,
.cell .table-cell-flex > span:first-child {
  text-overflow: ellipsis;
  overflow: hidden;
}
.item-divider {
  width: 3px;
  height: 12px;
  margin-right: 4px;
  background: var(--color-primary);
}
.g6-grid-container {
  z-index: 10;
}
.dashboard-designer .el-checkbox__label {
  padding-left: 6px;
}
.dashboard-designer .el-checkbox {
  color: var(--color-text-primary);
}
.el-select-dropdown__list .my-input-search {
  padding: 0 10px;
}
.el-select-dropdown__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media screen and (max-height: 768px) {
  .layui-dialog-warp .el-dialog__body {
    max-height: none !important;
  }
}
.dashboard-designer .layui-dialog-warp .el-dialog__footer {
  border-top: none;
  padding: 0;
}
.dashboard-designer .el-cascader__suggestion-list .hover {
  background-color: #f5f7fa;
}
.dashboard-designer .el-table th.table-header-gray {
  background-color: var(--bg-info-color);
  color: var(--color-text-regular);
}
.dashboard-designer .el-table--border th :not(:last-child):not(.el-checkbox__inner):after {
  content: "";
  display: none;
  width: 1px;
  height: 16px;
  position: absolute;
  background: #dfe2e8;
  right: 0;
  top: 5px;
}
.dashboard-designer .el-table--border th.is-leaf .cell:after {
  content: "";
  display: block;
  width: 1px;
  height: 16px;
  position: absolute;
  background: #dfe2e8;
  right: 0;
  top: 5px;
}
.dashboard-designer .el-table th:nth-last-child(2) .cell:after {
  display: none;
}
.dashboard-designer .el-table th:last-child .cell:after {
  display: none;
}
.dashboard-designer .el-table-column--selection .cell:after {
  display: none !important;
}
.dashboard-designer .el-table td,
.dashboard-designer .el-table th.is-leaf {
  border-color: transparent;
}
.dashboard-designer .el-table--border .el-table__cell {
  border-right: none;
  color: var(--text-color-level6);
}
.dashboard-designer .el-table--border,
.dashboard-designer .el-table--group {
  border: none;
}
.el-message {
  z-index: 99999 !important;
  padding: 10px 20px 10px 10px !important;
}
.el-message__closeBtn {
  right: 5px;
}
.el-message__content {
  padding-right: 25px !important;
}
.el-tag.render-tag-warp {
  border-color: transparent;
}
.text-overflow-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.el-scrollbar {
  width: 100%;
}
.el-button--small + .el-button--small {
  margin-left: 12px;
}
.el-message-box__btns .el-button--small {
  padding: var(--padding-gap-mini) var(--block-gap-primary);
  font-size: 12px;
}
.el-dialog__footer .el-button--mini + .el-button--mini {
  margin-left: 12px;
}
.info-toast-custom .el-icon-info {
  font-size: 14px !important;
  margin-top: -26px !important;
}
.custom-alert-info-detail {
  background-color: #eff7ff;
  padding: 10px 12px;
  margin-bottom: 12px;
  font-size: 12px;
  color: var(--text-color-level6);
}
.custom-alert-info-detail .tip-title {
  font-size: 12px;
  line-height: 20px;
}
.custom-alert-info-detail .tip-icon {
  font-size: 16px;
  color: var(--color-primary);
  margin-right: 6px;
  line-height: 20px;
}
.disable_maker {
  width: 6px;
  height: 6px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 6px;
  background: var(--text-color-level4);
}
.enable_maker {
  width: 6px;
  height: 6px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 6px;
  background: var(--color-success);
}
.custom-alert-info-detail {
  background-color: #eff7ff;
  padding: 10px 12px;
  margin-bottom: 12px;
  font-size: 12px;
  color: var(--text-color-level6);
}
.custom-alert-info-detail .tip-title {
  font-size: 12px;
  line-height: 20px;
}
.custom-alert-info-detail .tip-icon {
  font-size: 16px;
  color: var(--color-primary);
  margin-right: 6px;
  line-height: 20px;
}
.no-footer-dialog .el-dialog__footer {
  display: none;
}
.icon-sec {
  width: 60px;
  cursor: pointer;
  z-index: 9;
  top: 67px;
  display: flex;
  margin-right: 6px;
}
.icon-sec .icon-sec-left,
.icon-sec .icon-sec-right {
  width: 30px;
  height: 28px;
  border: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-sec .icon-sec-left {
  border-radius: 4px 0px 0px 4px;
}
.icon-sec .icon-sec-right {
  border-radius: 0px 4px 4px 0px;
}
.icon-sec .icon {
  font-size: 18px;
  line-height: 28px;
  color: #dbdbdb;
}
.icon-sec:hover {
  cursor: pointer;
}
.icon-sec .active {
  color: #3298ff;
}
.icon-sec .active-div {
  background: rgba(62, 123, 250, 0.1);
  border: 1px solid var(--color-primary);
}
.el-select-dropdown.el-popper.rule-config-popper {
  display: none;
}
input {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.customKnowMessage .el-icon-close:before {
  content: '我知道了';
  font-size: 14px;
  line-height: 20px;
  color: var(--color-primary);
}
.customKnowMessage .el-message__content {
  padding-right: 50px !important;
}
.el-message {
  max-width: 60%;
  max-height: 40%;
  word-break: break-all;
  overflow-y: auto;
}
.el-notification.centerNotify.right {
  left: 50%;
  transform: translate(-50%, 0);
  width: 420px;
}
.centerNotify .el-notification__title {
  font-size: 14px;
  color: #1d2129;
  line-height: 22px;
}
.centerNotify .el-notification__content {
  font-size: 12px;
  color: #4e5969;
  line-height: 20px;
}
.centerNotify .el-notification__icon {
  height: 14px;
  width: 14px;
  font-size: 16px;
  line-height: 22px;
}
.centerNotify .el-notification__group {
  margin-left: 8px;
}
.svgIcon {
  width: 24px;
  height: 24px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.vnode-radio .el-radio__label {
  display: none;
}
.db-form-item .el-form-item__label {
  line-height: 1.2;
}
.jzliu-bi-engine-export-prompt .el-message-box__content {
  display: flex;
  align-items: center;
}
.jzliu-bi-engine-export-prompt .el-message-box__container {
  margin-right: 12px;
}
.jzliu-bi-engine-export-prompt .el-message-box__input {
  flex: 1;
}
.jzliu-bi-engine-export-prompt .el-button--small {
  padding: 9px 15px !important;
  font-size: 12px !important;
  border-radius: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/base.less","webpack://./src/assets/style/transition.less"],"names":[],"mappings":"AAAA,OAAO;ACCP;;EAEE,yBAAA;ADCF;ACEA;;EAEE,UAAA;ADAF;AACA,OAAO;ACGP;;EAEE,oBAAA;ADDF;ACIA;;EAEE,UAAA;EACA,2BAAA;ADFF;ACKA;EACE,oBAAA;ADHF;ACMA;EACE,kBAAA;ADJF;AArBA;;EAEE,UAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,yHAAA;EAEA,gCAAA;AAsBF;AAnBA;;;EAGE,sBAAA;AAqBF;AAlBA;EACE,eAAA;AAoBF;AAjBA;EACE,cAAA;AAmBF;AAIA;EACE,2BAAA;AAFF;AAKA;EACE,2BAAA;AAHF;AAMA;EACE,0BAAA;AAJF;AAOA;EACE,2BAAA;AALF;AAQA;EACE,gCAAA;AANF;AASA;EACE,kCAAA;AAPF;AAUA;EACE,gCAAA;AARF;AAWA;EACE,+BAAA;AATF;AAYA;EACE,iBAAA;AAVF;AAaA;EACE,mBAAA;AAXF;AAcA;EACE,mBAAA;AAZF;AAeA;EACE,mBAAA;AAbF;AAgBA;EACE,kBAAA;AAdF;AAiBA;EACE,2BAAA;EACA,gBAAA;EACA,eAAA;AAfF;AAwCA;EACE,4BAAA;EACA,8CAAA;EACA,iDAAA;EACA,iBAAA;EACA,cAAA;AAtCF;AAyCA;EACE,gBAAA;AAvCF;AACA;;GAEG;AA0CH;EACE,8BAAA;EACA,2BAAA;AAxCF;AA2CA;EACE,WAAA;AAzCF;AA4CA;EACE,kBAAA;EACA,2BAAA;AA1CF;AA6CA;EACE,aAAA;AA3CF;AACA;;EAEE;AA8CF;EACE,kBAAA;EACA,2BAAA;EACA,yBAAA;AA5CF;AA+CA;EACE,8BAAA;EACA,2BAAA;AA7CF;AAgDA;EACE,iBAAA;AA9CF;AAiDA;EACE,gBAAA;AA/CF;AAkDA;EACE,aAAA;AAhDF;AAmDA;EACE,eAAA;AAjDF;AAoDA;EACE,kBAAA;AAlDF;AAqDA;EACE,eAAA;EACA,gBAAA;AAnDF;AAsDA;EACE,aAAA;AApDF;AAuDA;EACE,2BAAA;AArDF;AAwDA;EACE,0CAAA;AAtDF;AAyDA;EACE,+CAAA;AAvDF;AA0DA;EACE,gDAAA;AAxDF;AA2DA;EACE,8CAAA;AAzDF;AA4DA;EACE,iDAAA;AA1DF;AA6DA;EACE,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AA3DF;AAmDA;EAWI,yBAAA;EACA,YAAA;EACA,gBAAA;AA3DJ;AA+DA;EACE,4BAAA;AA7DF;AAgEA;EACE,gCAAA;EACA,kCAAA;EACA,WAAA;AA9DF;AAiEA;;;;EAIE,qBAAA;EACA,mBAAA;AA/DF;AAkEA;EACE,2BAAA;AAhEF;AAmEA;EACE,oCAAA;AAjEF;AAoEA;EACE,2BAAA;EACA,mBAAA;EACA,qBAAA;AAlEF;AAqEA;EACE,YAAA;AAnEF;AAsEA;EACE,kCAAA;EACA,WAAA;EACA,sCAAA;AApEF;AACA;;GAEG;AAuEH;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,MAAA;EACA,WAAA;AArEF;AAwEA;EACE,kBAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;AAtEF;AAyEA;EACE,oBAAA;AAvEF;AA0EA;EACE,YAAA;AAxEF;AA2EA;EACE,uBAAA;AAzEF;AA4EA;;EAEE,YAAA;AA1EF;AA6EA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;AA3EF;AA8EA;EACE,iBAAA;AA5EF;AACA;;GAEG;AA+EH;EACE,+BAAA;AA7EF;AA4EA;EAII,YAAA;AA7EJ;AAyEA;EAQI,YAAA;EACA,iBAAA;EACA,WAAA;AA9EJ;AAoEA;EAaM,aAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;AA9EN;AAiFI;EACE,cAAA;AA/EN;AA2DA;EAyBI,gBAAA;AAjFJ;AACA;;GAEG;AAqFH;EAEI,WAAA;AApFJ;AAkFA;EAMI,WAAA;AArFJ;AA+EA;EAUI,WAAA;AAtFJ;AA4EA;EAcI,WAAA;AAvFJ;AAyEA;EAkBI,WAAA;AAxFJ;AA4FA;EACE,gBAAA;AA1FF;AA6FA;EACE,gBAAA;AA3FF;AA8FA;EACE,gBAAA;AA5FF;AA+FA;EACE,gBAAA;AA7FF;AAgGA;EACE,iBAAA;AA9FF;AAiGA;EACE,uBAAA;AA/FF;AAsGA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AApGF;AAuGA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AArGF;AACA;;GAEG;AAoJH;EACE,kBAAA;AAlJF;AACA;;GAEG;AAqJH;;EAEE,yBAAA;AAnJF;AAsJA;EACE,oCAAA;AApJF;AACA;;GAEG;AAuJH;EACE,cAAA;AArJF;AAwJA;EACE,cAAA;AAtJF;AAyJA;EACE,cAAA;AAvJF;AA0JA;EACE,cAAA;AAxJF;AA2JA;EACE,cAAA;AAzJF;AA4JA;EACE,cAAA;AA1JF;AA6JA;EACE,cAAA;AA3JF;AA8JA;EACE,cAAA;AA5JF;AA+JA;EACE,cAAA;AA7JF;AAgKA;;EAEE,UAAA;AA9JF;AACA;;GAEG;AAiKH;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA/JF;AAyJA;EASI,iBAAA;AA/JJ;AAmKA;EACE,eAAA;AAjKF;AAoKA;EACE,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAlKF;AAqKA;EACE,sCAAA;AAnKF;AAsKA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AApKF;AAuKA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AArKF;AAwKA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAtKF;AAyKA;EACE,WAAA;EACA,YAAA;AAvKF;AA0KA;EACE,WAAA;EACA,YAAA;AAxKF;AA2KA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAzKF;AACA;;GAEG;AA8KH;EACE,YAAA;EACA,8CAAA;EAEA,6CAAA;AA7KF;AAgLA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AA9KF;AAiLA;EACE,kBAAA;AA/KF;AA8KA;EAII,4BAAA;AA/KJ;AAmLA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;AAjLF;AA2KA;EASI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAjLJ;AAqLA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AAnLF;AAsLA;EACE,uBAAA;AApLF;AAuLA;EACE,YAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;AArLF;AAwLA;EACE,mBAAA;AAtLF;AAyLA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAvLF;AA0LA;EACE,eAAA;EACA,2BAAA;AAxLF;AAsLA;EAKI,gBAAA;EACA,iBAAA;EACA,YAAA;AAxLJ;AA4LA;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AA1LF;AA6LA;EACE,qBAAA;AA3LF;AA8LA;EAEI,YAAA;EACA,iBAAA;EACA,mBAAA;AA7LJ;AAiMA;EAEI,2BAAA;EACA,gBAAA;AAhMJ;AAoMA;EAEI,cAAA;EACA,eAAA;EACA,0BAAA;AAnMJ;AAuMA;EACE,2BAAA;AArMF;AAwMA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAtMF;AAyMA;EAEE,aAAA;EACA,yBAAA;AAxMF;AAqMA;EAMI,0BAAA;AAxMJ;AA4MA;EACE,8BAAA;EACA,UAAA;AA1MF;AA6MA;EACE,kBAAA;AA3MF;AA8MA;EACE,uBAAA;AA5MF;AA+MA;EACE,gBAAA;AA7MF;AAgNA;EACE,6BAAA;AA9MF;AAiNA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;AA/MF;AAkNA;EACE,cAAA;AAhNF;AAmNA;EACE,qBAAA;EACA,YAAA;EACA,iBAAA;AAjNF;AAoNA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAlNF;AAqNA;EACE,sBAAA;AAnNF;AAsNA;EACE,mBAAA;AApNF;AAuNA;EACE,mBAAA;AArNF;AAwNA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,iBAAA;AAtNF;AAyNA;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;AAvNF;AA0NA;EACE,QAAA;AAxNF;AA2NA;EACE,QAAA;AAzNF;AA4NA;EACE,QAAA;AA1NF;AA6NA;EACE,SAAA;AA3NF;AA8NA;EACE,iBAAA;AA5NF;AA+NA;EACE,YAAA;AA7NF;AAgOA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AA9NF;AAiOA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AA/NF;AAkOA;EACE,+BAAA;EAEA,kBAAA;AAjOF;AAoOA;EACE,mBAAA;AAlOF;AAqOA;EACE,iBAAA;AAnOF;AAsOA;EACE,kBAAA;AApOF;AAuOA;EACE,gBAAA;AArOF;AAwOA;EACE,gBAAA;AAtOF;AAyOA;EACE,eAAA;AAvOF;AA0OA;EACE,mBAAA;AAxOF;AA2OA;EACE,kBAAA;AAzOF;AA4OA;EACE,mBAAA;AA1OF;AA6OA;EACE,iBAAA;AA3OF;AA8OA;EACE,oBAAA;AA5OF;AA+OA;EACE,kBAAA;AA7OF;AAgPA;EACE,mBAAA;AA9OF;AAiPA;EACE,iBAAA;AA/OF;AAkPA;EACE,oBAAA;AAhPF;AAmPA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAjPF;AAoPA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,8BAAA;EACA,YAAA;AAlPF;AA2OA;EAUI,eAAA;EACA,gBAAA;EACA,gCAAA;AAlPJ;AAsPA;EAIQ,YAAA;EACA,uBAAA;AAvPR;AA6PA;;;;;;EAME,gBAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;AA3PF;AAuQA;EACE,sBAAA;AArQF;AAwQA;EAEE,iBAAA;EACA,cAAA;AAvQF;AA0QA;EACE,sBAAA;AAxQF;AA2QA;EACE,sBAAA;AAzQF;AA4QA;EACE,yHAAA;AA1QF;AA8QA;EACE,cAAA;AA5QF;AA+QA;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;AA7QF;AAgRA;EACE,gCAAA;EACA,0CAAA;EACA,+BAAA;AA9QF;AAiRA;EACE,uCAAA;EACA,sCAAA;EACA,2BAAA;AA/QF;AAkRA;EACE,qCAAA;EACA,qCAAA;EACA,0BAAA;AAhRF;AAmRA;EACE,uCAAA;EACA,sCAAA;EACA,2BAAA;AAjRF;AAoRA;EACE,uCAAA;EACA,sCAAA;EACA,2BAAA;AAlRF;AAqRA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AAnRF;AAsRA;EACE,iBAAA;AApRF;AAuRA;EACE,mBAAA;AArRF;AAoRA;EAII,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AArRJ;AAuRI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,OAAA;EACA,UAAA;EACA,sCAAA;AArRN;AA0RA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAxRF;AA2RA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAzRF;AAsRA;EAMI,YAAA;AAzRJ;AAmRA;;EAWI,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA1RJ;AA2QA;EAoBM,gCAAA;AA5RN;AAiSA;EACE,6BAAA;AA/RF;AAkSA;EACE,+BAAA;AAhSF;AAmSA;EACE,2BAAA;AAjSF;AAoSA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AAlSF;AAyRA;EAYI,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAlSJ;AAmRA;EAmBI,iBAAA;EACA,eAAA;AAnSJ;AAuSA;EACE,WAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;AArSF;AAwSA;;EAII,iBAAA;AAxSJ;AA4SA;EACE,eAAA;AA1SF;AA6SA;EACE,2BAAA;AA3SF;AA8SA;EACE,0BAAA;EACA,mBAAA;EACA,eAAA;AA5SF;AA+SA;EACE,WAAA;AA7SF;AAgTA;EACE,qBAAA;AA9SF;AAqTA;EAEI,gBAAA;AApTJ;AA4TA;EACE,YAAA;AA1TF;AA6TA;EACE,aAAA;AA3TF;AA0TA;EAII,uBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA3TJ;AA+SA;EAeM,QAAA;EACA,SAAA;EACA,6BAAA;EACA,SAAA;EACA,4BAAA;EACA,kBAAA;AA3TN;AAuSA;EAwBM,yCAAA;AA5TN;AAoSA;EA4BM,QAAA;EACA,SAAA;EACA,6BAAA;EACA,SAAA;EACA,yBAAA;AA7TN;AA6RA;EAoCM,sCAAA;AA9TN;AAmUA;EACE,kBAAA;EACA,oDAAA;AAjUF;AAoUA;EACE,kBAAA;EACA,iDAAA;AAlUF;AAqUA;EACE,2BAAA;EACA,kCAAA;AAnUF;AAsUA;;EAEE,2BAAA;AApUF;AAuUA;EACE,wBAAA;AArUF;AAwUA;EACE,2BAAA;EACA,eAAA;EACA,eAAA;AAtUF;AAyUA;EACE,aAAA;AAvUF;AA0UA;EACE,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gCAAA;AAxUF;AA0UE;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,SAAA;EACA,sBAAA;AAxUJ;AA2UE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;AAzUJ;AA+SA;EA8BI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,+BAAA;AA1UJ;AA8UA;EAEI,eAAA;EACA,iBAAA;AA7UJ;AA0UA;EAOI,eAAA;EACA,iBAAA;AA9UJ;AAuWA;EACE,kBAAA;AArWF;AAwWA;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,0EAAA;EACA,kBAAA;AAtWF;AAyWA;;EAEE,6BAAA;EACA,oBAAA;EACA,kBAAA;AAvWF;AA0WA;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;AAxWF;AA2WA;EAEE,kBAAA;AA1WF;AA2XA;EACE,aAAA;AAzXF;AA4XA;;EAEE,uBAAA;EACA,gBAAA;AA1XF;AA6XA;EACE,UAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;AA3XF;AA8XA;EACE,WAAA;AA5XF;AA+XA;EACE,iBAAA;AA7XF;AAgYA;EACE,gCAAA;AA9XF;AAiYA;EAEI,eAAA;AAhYJ;AAoYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAlYF;AAqYA;EACE;IACE,2BAAA;EAnYF;AACF;AAsYA;EAMI,gBAAA;EACA,UAAA;AAzYJ;AA6YA;EAEI,yBAAA;AA5YJ;AAiZA;EACE,sCAAA;EACA,gCAAA;AA/YF;AAoZI;EACE,WAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,QAAA;AAlZN;AAwZE;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,QAAA;AAtZJ;AA2ZE;EACE,aAAA;AAzZJ;AA8ZE;EACE,aAAA;AA5ZJ;AAiaE;EACE,wBAAA;AA/ZJ;AAmaA;;EAEE,yBAAA;AAjaF;AAoaA;EACE,kBAAA;EACA,+BAAA;AAlaF;AAqaA;;EAEE,YAAA;AAnaF;AAsaA;EACE,yBAAA;EACA,uCAAA;AApaF;AAuaA;EACE,UAAA;AAraF;AAwaA;EACE,8BAAA;AAtaF;AAyaA;EACE,yBAAA;AAvaF;AA0aA;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,mBAAA;AAxaF;AA2aA;EACE,WAAA;AAzaF;AA4aA;EACE,iBAAA;AA1aF;AA6aA;EACE,yDAAA;EACA,eAAA;AA3aF;AA8aA;EACE,iBAAA;AA5aF;AA+aA;EAEI,0BAAA;EACA,4BAAA;AA9aJ;AAkbA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;AAhbF;AA2aA;EAQI,eAAA;EACA,iBAAA;AAhbJ;AAuaA;EAaI,eAAA;EACA,2BAAA;EACA,iBAAA;EACA,iBAAA;AAjbJ;AAqbA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;AAnbF;AAsbA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;AApbF;AAubA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;AArbF;AAgbA;EAQI,eAAA;EACA,iBAAA;AArbJ;AA4aA;EAaI,eAAA;EACA,2BAAA;EACA,iBAAA;EACA,iBAAA;AAtbJ;AA0bA;EACE,aAAA;AAxbF;AA4bA;EACE,WAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;AA1bF;AAobA;;EAUI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1bJ;AA2aA;EAmBI,8BAAA;AA3bJ;AAwaA;EAuBI,8BAAA;AA5bJ;AAqaA;EA2BI,eAAA;EACA,iBAAA;EACA,cAAA;AA7bJ;AAgcE;EACE,eAAA;AA9bJ;AA6ZA;EAqCI,cAAA;AA/bJ;AA0ZA;EAyCI,mCAAA;EACA,sCAAA;AAhcJ;AAocA;EACE,aAAA;AAlcF;AAqcA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AAncF;AAscA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AApcF;AAucA;EACE,8BAAA;AArcF;AAwcA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AAtcF;AAycA;EACE,SAAA;EACA,6BAAA;EACA,YAAA;AAvcF;AA0cA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAxcF;AA2cA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAzcF;AA4cA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AA1cF;AA6cA;EACE,gBAAA;AA3cF;AA+cA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AA7cF;AAgdA;EACE,aAAA;AA9cF;AAidA;EACE,gBAAA;AA/cF;AAkdA;EAEI,aAAA;EACA,mBAAA;AAjdJ;AA8cA;EAOI,kBAAA;AAldJ;AA2cA;EAWI,OAAA;AAndJ;AAwcA;EAeI,4BAAA;EACA,0BAAA;EACA,kBAAA;AApdJ","sourcesContent":["@import './element-variables.less';\n@import './transition.less';\n\nhtml,\nbody {\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  font-size: 12px;\n  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,\n    sans-serif;\n  color: var(--color-text-primary)\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n.orange-project .iconfont {\n  font-size: 20px;\n}\n\n.must-input-color {\n  color: #ff4141;\n}\n\n@header-height: 60px;\n\n// 过滤组件长度\n@filter-item-width: 250px;\n// 范围选择过滤组件长度\n@filter-item-range-width: 400px;\n// 左侧过滤树组件每一项高度\n@tree-node-height: 40px;\n// 高级管理表单标题高度\n@advanced-title-height: 50px;\n@border-color: rgb(216, 220, 229);\n@menuHover: rgba(255, 255, 255, 0.3);\n@menu-background-color: transparent;\n@tabs-header-margin-bottom: 25px;\n@tab-header-background-color: #ebeef5;\n@image-item-width: 65px;\n@box-padding-size: 25px;\n@left-menu-height: 47px;\n@left-submenu-height: 43px;\n\n.color1 {\n  color: var(--color-primary);\n}\n\n.primary-color {\n  color: var(--color-primary);\n}\n\n.error-color {\n  color: var(--color-danger);\n}\n\n.warning-color {\n  color: var(--color-warning);\n}\n\n.content-color {\n  color: var(--color-text-primary);\n}\n\n.secondary-color {\n  color: var(--color-text-secondary);\n}\n\n.regular-color {\n  color: var(--color-text-regular);\n}\n\n.tip-color {\n  color: var(--text-color-level3);\n}\n\n.ml-12px {\n  margin-left: 12px;\n}\n\n.mb-12px {\n  margin-bottom: 12px;\n}\n\n.mb-36px {\n  margin-bottom: 36px;\n}\n\n.mt-24px {\n  margin-bottom: 24px;\n}\n\n.mb-6px {\n  margin-bottom: 6px;\n}\n\n.el-icon-question-helper {\n  color: var(--color-primary);\n  margin-left: 2px;\n  font-size: 14px;\n}\n\n// 左侧菜单树样式覆盖 高度修改会引起item下移 去掉\n//.el-menu-item{\n//  height: @left-menu-height;\n//  line-height: @left-menu-height;\n//}\n//\n//.el-submenu .el-menu-item{\n//  height: @left-submenu-height;\n//  line-height: @left-submenu-height;\n//}\n//.el-submenu__title{\n//  height: @left-menu-height;\n//  line-height: @left-menu-height;\n//}\n//dialog 弹框样式重写\n@media screen and (max-height: 768px) {\n  .el-dialog__body {\n    //max-height: 350px !important;\n  }\n}\n\n// el-dialog__footer的高度是52px, 所以把border加到el-dialog__body上\n.el-dialog__body {\n  padding: 16px 20px 20px 20px;\n  border-top: 1px solid var(--line-color-level1);\n  border-bottom: 1px solid var(--line-color-level1);\n  max-height: 497px;\n  overflow: auto;\n}\n\n.el-dialog__wrapper[fullscreen='true'] .el-dialog__body {\n  max-height: none;\n}\n\n/**\n * 弹窗样式，封装的layer的弹窗\n **/\nbody .layer-dialog .layui-layer-title {\n  border-radius: 4px 4px 0px 0px;\n  border: 1px solid #01000000;\n}\n\nbody .layer-dialog .layui-layer-setwin {\n  color: #fff;\n}\n\nbody .layer-dialog {\n  border-radius: 4px;\n  border: 1px solid #01000000;\n}\n\nbody .layer-dialog .layui-layer-content {\n  padding: @box-padding-size;\n}\n\n/**\n * 左树右表弹窗样式\n */\nbody .layer-advance-dialog {\n  border-radius: 4px;\n  border: 1px solid #01000000;\n  background-color: #f8f8f8;\n}\n\nbody .layer-advance-dialog .layui-layer-title {\n  border-radius: 4px 4px 0px 0px;\n  border: 1px solid #01000000;\n}\n\nbody .layer-advance-dialog .layui-layer-content {\n  padding: 5px 15px;\n}\n\n.orange-project {\n  overflow: hidden;\n}\n\n.el-main {\n  padding: 16px;\n}\n\n.flex-box {\n  flex-wrap: wrap;\n}\n\n.scrollbar_dropdown__wrap {\n  overflow-x: hidden;\n}\n\n.icon-btn.el-button {\n  font-size: 18px;\n  padding: 5px 0px;\n}\n\n.default-padding-box {\n  padding: @box-padding-size;\n}\n\n.padding-no-top {\n  padding: 0px @box-padding-size @box-padding-size @box-padding-size;\n}\n\n.default-border {\n  border: 1px solid var(--border-color-base);\n}\n\n.default-border-left {\n  border-left: 1px solid var(--border-color-base);\n}\n\n.default-border-right {\n  border-right: 1px solid var(--border-color-base);\n}\n\n.default-border-top {\n  border-top: 1px solid var(--border-color-base);\n}\n\n.default-border-bottom {\n  border-bottom: 1px solid var(--border-color-base);\n}\n\n.page-close-box {\n  position: absolute;\n  background: #0092ff;\n  transform: rotate(45deg);\n  height: 50px;\n  width: 50px;\n  right: -25px;\n  top: -25px;\n  text-align: center;\n\n  .el-button {\n    transform: rotate(-45deg);\n    color: white;\n    margin-top: 20px;\n  }\n}\n\n.el-button+.btn-import {\n  margin-left: 10px !important;\n}\n\n.dashboard-designer .el-button--primary {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: #fff;\n}\n\n.dashboard-designer .el-button--primary.is-disabled,\n.dashboard-designer .el-button--primary.is-disabled:hover,\n.dashboard-designer .el-button--primary.is-disabled:focus,\n.dashboard-designer .el-button--primary.is-disabled:active {\n  border-color: #bad7ff;\n  background: #bad7ff;\n}\n\n.dashboard-designer .el-button--text {\n  color: var(--color-primary);\n}\n\n.dashboard-designer .el-button.is-disabled.el-button--text {\n  color: var(--disabled-primary-color);\n}\n\n.dashboard-designer .el-button--primary.is-plain {\n  color: var(--color-primary);\n  background: #ecf5ff;\n  border-color: #b3d8ff;\n}\n\n.dashboard-designer .textarea-disabled-resize textarea {\n  resize: none;\n}\n\n.dashboard-designer .is-process .el-step__icon.is-text {\n  border-color: var(--color-primary);\n  color: #fff;\n  background-color: var(--color-primary);\n}\n\n/**\n * 过滤组件样式\n **/\n.mask-box {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  top: 0;\n  z-index: 10;\n}\n\n.filter-box {\n  position: relative;\n  background-color: white;\n  padding: @box-padding-size @box-padding-size 0px @box-padding-size;\n  z-index: 20;\n}\n\n.advance-filter-box {\n  padding-bottom: 25px;\n}\n\n.filter-item {\n  width: @filter-item-width;\n}\n\n.cascader-item {\n  width: 160px !important;\n}\n\n.is-range,\n.is-search {\n  width: @filter-item-range-width;\n}\n\n.table-operation-box {\n  align-self: flex-end;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.table-check-box {\n  margin-right: 7px;\n}\n\n/**\n * 左侧树状组件的样式，用户高级管理表单以及用户管理表单\n **/\n.advanced-left-box {\n  border-right: 1px solid @border-color;\n\n  .el-tree-node__content {\n    height: @tree-node-height;\n  }\n\n  .tree-node-item {\n    height: @tree-node-height;\n    line-height: @tree-node-height;\n    width: 100%;\n\n    .tree-node-menu {\n      display: none;\n      float: right;\n      padding-right: 10px;\n      color: var(--color-danger) !important;\n    }\n\n    &:hover .tree-node-menu {\n      display: block;\n    }\n  }\n\n  .el-tree-node .el-button+.el-button {\n    margin-left: 5px;\n  }\n}\n\n/**\n * form表单输入组件宽度\n **/\n.full-width-input {\n  .el-select {\n    width: 100%;\n  }\n\n  .el-input {\n    width: 100%;\n  }\n\n  .el-cascader {\n    width: 100%;\n  }\n\n  .el-date-editor {\n    width: 100%;\n  }\n\n  .el-input-number {\n    width: 100%;\n  }\n}\n\n.el-form-item.el-form-item--mini {\n  min-height: 29px;\n}\n\n.el-form-item.el-form-item--small {\n  min-height: 32px;\n}\n\n.el-form-item.el-form-item--medium {\n  min-height: 36px;\n}\n\n.el-form-item.el-form-item--default {\n  min-height: 40px;\n}\n\n.el-aside {\n  overflow: visible;\n}\n\n.el-menu {\n  border-right-width: 0px;\n}\n\n.sidebar-bg {\n  // box-shadow: 0 1px 4px rgba(0,21,41,.08)!important;\n}\n\n.sidebar-title {\n  display: flex;\n  align-items: center;\n  height: 58px;\n  padding-left: 20px;\n  white-space: nowrap;\n}\n\n.sidebar-title-text {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: @--color-sidebar-title-text;\n  padding-left: 8px;\n}\n\n.el-menu:not(.el-menu--horizontal) .el-menu-item.is-active when (isdefined(@--color-menu-item-active-text-color)) {\n  color: @--color-menu-item-active-text-color !important;\n  font-weight: 700;\n  border-right: 4px solid var(--color-primary);\n}\n\n//  //li.el-menu-item::after {\n//  //  display:block;\n//  //  content:attr(title);\n//  //  font-weight:bold;\n//  //  visibility:hidden;\n//  //  height:1px;\n//  //  color:transparent;\n//  //  margin-bottom:-1px;\n//  //  overflow:hidden;\n//  //}\n//\n//  //.el-menu:not(.el-menu--horizontal) .el-submenu__title i {\n//  //  color: @--color-menu-item-active-text-color;\n//  //}\n.el-scrollbar when (isdefined(@--color-menu-item-active-background)) {\n  .el-menu:not(.el-menu--horizontal) .el-menu-item.is-active when (isdefined(@--color-menu-item-active-background-to)) {\n    background: linear-gradient(to left,\n        @--color-menu-item-active-background,\n        @--color-menu-item-active-background-to);\n  }\n\n  .el-menu:not(.el-menu--horizontal) .el-menu-item.is-active when not(isdefined(@--color-menu-item-active-background-to)) {\n    background: @--color-menu-item-active-background;\n  }\n\n  .el-menu:not(.el-menu--horizontal) .el-menu-item:hover when (isdefined(@--color-menu-item-active-background-to)) {\n    background: linear-gradient(to left,\n        @--color-menu-item-active-background,\n        @--color-menu-item-active-background-to);\n    color: @--color-menu-item-active-text-color;\n  }\n\n  .el-menu:not(.el-menu--horizontal) .el-menu-item:hover when not(isdefined(@--color-menu-item-active-background-to)) {\n    background: @--color-menu-item-active-background;\n    color: @--color-menu-item-active-text-color;\n  }\n}\n\n/**\n * 多tab页表单，tab样式\n **/\n.dashboard-designer .el-tabs__header {\n  margin: 8px 0 16px;\n}\n\n/**\n * 表格表头背景色\n **/\n.table-header-gray,\n.has-gutter .gutter {\n  background-color: @tab-header-background-color;\n}\n\n.table-header-gray th.el-table__cell {\n  background-color: #f7f8fa !important;\n}\n\n/**\n * 操作按钮颜色\n **/\n.table-btn.delete {\n  color: #f56c6c;\n}\n\n.table-btn.delete:hover {\n  color: #f78989;\n}\n\n.table-btn.delete:disabled {\n  color: #dcdfe6;\n}\n\n.table-btn.success {\n  color: #67c23a;\n}\n\n.table-btn.success:hover {\n  color: #85ce61;\n}\n\n.table-btn.success:disabled {\n  color: #dcdfe6;\n}\n\n.table-btn.warning {\n  color: #e6a23c;\n}\n\n.table-btn.warning:hover {\n  color: #ebb563;\n}\n\n.table-btn.success:disabled {\n  color: #dcdfe6;\n}\n\n.el-table--group::after,\n.el-table--border::after {\n  width: 0px;\n}\n\n/**\n * 图片上传以及显示样式\n **/\n.upload-image-item {\n  font-size: 28px;\n  color: #8c939d;\n  width: @image-item-width;\n  height: @image-item-width;\n  text-align: center;\n  display: block;\n\n  .el-upload i {\n    line-height: @image-item-width;\n  }\n}\n\n.upload-image-multi {\n  display: inline;\n}\n\n.upload-image-item .el-upload {\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.upload-image-item .el-upload:hover {\n  border-color: var(bi-jz-primary-color);\n}\n\n.upload-image-show {\n  width: @image-item-width;\n  height: @image-item-width;\n  display: inline;\n}\n\n.table-cell-image {\n  width: @image-item-width;\n  height: @image-item-width;\n  line-height: @image-item-width;\n  text-align: center;\n  font-size: @image-item-width;\n  color: #606266;\n  margin: 0px 5px;\n}\n\n.upload-image-list .el-upload-list__item {\n  width: @image-item-width;\n  height: @image-item-width;\n  line-height: @image-item-width;\n}\n\n.upload-image-item .el-upload-list--picture-card .el-upload-list__item {\n  width: @image-item-width;\n  height: @image-item-width;\n}\n\n.upload-image-item .el-upload.el-upload--text {\n  width: @image-item-width;\n  height: @image-item-width;\n}\n\n.upload-image-item .el-upload--picture-card {\n  width: @image-item-width;\n  height: @image-item-width;\n  line-height: @image-item-width;\n}\n\n/**\n *\n **/\n@header-menu-height: 32px;\n\n.sidebar {\n  height: 100%;\n  background-color: var(--color-menu-background);\n  // overflow: hidden;\n  box-shadow: 0px 1px 4px rgba(0, 21, 41, 0.08);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  height: @header-height;\n  background-color: white;\n}\n\n.header .menu-column {\n  margin-right: 20px;\n\n  .el-menu-item.is-active {\n    border-left: 0 solid #47ba5a;\n  }\n}\n\n.header-menu {\n  float: right;\n  height: @header-menu-height;\n  line-height: @header-menu-height;\n  display: flex;\n  justify-content: flex-end;\n  flex-grow: 1;\n\n  .circle {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #ff4141;\n    position: absolute;\n    right: -3px;\n    top: -2px;\n  }\n}\n\n.header-img {\n  width: @header-menu-height;\n  height: @header-menu-height;\n  border-radius: 50%;\n  margin-left: 10px;\n  float: right;\n}\n\n.el-menu--horizontal.el-menu {\n  background-color: white;\n}\n\n.el-menu--horizontal>.el-menu-item {\n  height: 40px;\n  line-height: 40px;\n  padding: 0;\n  margin: 0 20px;\n}\n\n.el-menu.el-menu--horizontal {\n  border-bottom: none;\n}\n\n.user-dropdown {\n  color: @--color-text-secondary;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.user-dropdown-item {\n  font-size: 12px;\n  color: var(--color-primary);\n\n  .el-badge {\n    margin-top: -8px;\n    margin-left: 10px;\n    height: 20px;\n  }\n}\n\n.hamburger-container {\n  line-height: 70px;\n  height: @header-height;\n  float: left;\n  padding: 0 10px;\n}\n\n.el-submenu__title {\n  background: #00000000;\n}\n\n.tree-select {\n  .el-tree-node__content {\n    height: 34px;\n    line-height: 34px;\n    padding-right: 10px;\n  }\n}\n\n.tree-select.single-select-tree {\n  .el-tree-node.is-current>.el-tree-node__content>.el-tree-node__label {\n    color: var(--color-primary);\n    font-weight: 700;\n  }\n}\n\n.cell {\n  .operation-cell {\n    color: #006cdc;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\n.single-select-tree {\n  min-width: 200px !important;\n}\n\n.base-card-header {\n  display: flex;\n  align-items: center;\n  height: 50px;\n  line-height: 50px;\n}\n\n.base-card-operation {\n  //flex-grow: 1;\n  display: flex;\n  justify-content: flex-end;\n\n  .el-button i {\n    font-size: 16px !important;\n  }\n}\n\n.el-card__header {\n  margin: 0 var(--block-gap-pro);\n  padding: 0;\n}\n\n.el-card__body {\n  padding: 12px 16px;\n}\n\n.custom-cascader {\n  width: 200px !important;\n}\n\n.no-scroll {\n  overflow: hidden;\n}\n\n.custom-scroll .el-scrollbar__view {\n  overflow-x: hidden !important;\n}\n\n.upload-img-del {\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  line-height: 20px;\n  font-size: 16px;\n  top: 2px;\n  right: 2px;\n  color: #c0c4cc;\n}\n\n.upload-img-del:hover {\n  color: #ef5e1c;\n}\n\n.input-label {\n  display: inline-block;\n  height: 29px;\n  line-height: 28px;\n}\n\n.input-progress {\n  height: 29px;\n  display: flex;\n  align-items: center;\n}\n\n.input-item {\n  width: 100% !important;\n}\n\n.table-header-gray {\n  background: #fafafa;\n}\n\n.table-header-custom {\n  background: #f6f9fb;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0px;\n  line-height: 28px;\n}\n\n.delete-confirm .el-message-box__btns .el-button--primary {\n  color: #fff;\n  background: #f53f3f;\n  border-color: #f53f3f;\n}\n\n.multi-text .el-message-box__content .el-message-box__container .el-message-box__status {\n  top: 14%;\n}\n\n.multi-text-top .el-message-box__content .el-message-box__container .el-message-box__status {\n  top: 30%;\n}\n\n.multi-text-tip .el-message-box__content .el-message-box__container .el-message-box__status {\n  top: 19%;\n}\n\n.multi-two-lines-text-tip .el-message-box__content .el-message-box__container .el-message-box__status {\n  top: 12px;\n}\n\n.display-right {\n  margin-left: auto;\n}\n\n.filter-item-date {\n  width: 330px;\n}\n\n.form-online .el-dialog .el-dialog__body {\n  max-height: 450px;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n  background: none;\n  margin-right: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.15);\n  ;\n  border-radius: 2px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n.ml20 {\n  margin-left: 20px;\n}\n\n.mr20 {\n  margin-right: 20px;\n}\n\n.mt20 {\n  margin-top: 20px;\n}\n\n.mt12 {\n  margin-top: 12px;\n}\n\n.mt6 {\n  margin-top: 6px;\n}\n\n.mb20 {\n  margin-bottom: 20px;\n}\n\n.pl20 {\n  padding-left: 20px;\n}\n\n.pr20 {\n  padding-right: 20px;\n}\n\n.pt20 {\n  padding-top: 20px;\n}\n\n.pb20 {\n  padding-bottom: 20px;\n}\n\n.gutter-left {\n  padding-left: 20px;\n}\n\n.gutter-right {\n  padding-right: 20px;\n}\n\n.gutter-top {\n  padding-top: 20px;\n}\n\n.gutter-bottom {\n  padding-bottom: 20px;\n}\n\n.page_box {\n  margin-top: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.list-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #ebeef5;\n  margin: -14px -20px 16px -20px;\n  height: 50px;\n\n  .text {\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--color-text-primary);\n  }\n}\n\n.el-message-box__wrapper {\n  .message_box {\n    .el-message-box__content {\n      .el-message-box__input {\n        width: 280px;\n        margin: -50px 0 0 100px;\n      }\n    }\n  }\n}\n\n.el-table .cell,\n.planList .tb-flex .text,\n.ty_flex .nameLabel,\n.el-table .cell>div:first-child,\n.vxe-table--render-wrapper .vxe-cell,\n.el-table .cell .el-button--text {\n  overflow: hidden;\n  white-space: nowrap !important;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\n//.el-table .cell > div:first-child {\n//  display: flex;\n//  align-items: center;\n//}\n//.el-table .cell div:first-child, .el-table .cell span:first-child {\n//  overflow: hidden;\n//  text-overflow: ellipsis;\n//}\n\n.el-table .cell img {\n  vertical-align: middle;\n}\n\n.base-conf-dialog .el-dialog__body {\n  //min-height: 400px;\n  max-height: 500px;\n  overflow: auto;\n}\n\n.el-checkbox__inner {\n  border: 1px solid #999;\n}\n\n.el-radio__inner {\n  border: 1px solid #999;\n}\n\n.el-textarea__inner {\n  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,\n    sans-serif;\n}\n\n.stopUsing {\n  color: #aaaaaa;\n}\n\n.defaultBox {\n  background: #fbfbfb;\n  border: 1px solid #d9d9d9;\n  color: #000;\n}\n\n.greyBox {\n  background: var(--bg-info-color);\n  border: 1px solid var(--text-color-level4);\n  color: var(--text-color-level4);\n}\n\n.greenBox {\n  background: var(--success-color-level1);\n  border: 1px solid var(--color-success);\n  color: var(--color-success);\n}\n\n.redBox {\n  background: var(--error-color-level1);\n  border: 1px solid var(--color-danger);\n  color: var(--color-danger);\n}\n\n.yellowBox {\n  background: var(--warning-color-level1);\n  border: 1px solid var(--color-warning);\n  color: var(--color-warning);\n}\n\n.blueBox {\n  background: var(--primary-color-level1);\n  border: 1px solid var(--color-primary);\n  color: var(--color-primary);\n}\n\n.purpleBox {\n  background: #F9F0FF;\n  border: 1px solid #EDD6FF;\n  color: #9D57F2;\n}\n\n.tableTagMargin {\n  margin-right: 4px;\n}\n\n.detail-card {\n  margin-bottom: 20px;\n\n  .detail-title {\n    position: relative;\n    padding-left: 8px;\n    font-weight: bold;\n    color: rgb(40, 40, 40);\n    font-size: 14px;\n    margin-bottom: 16px;\n\n    &:after {\n      position: absolute;\n      content: '';\n      height: 90%;\n      top: 5%;\n      left: 0;\n      width: 3px;\n      background-color: var(--color-primary);\n    }\n  }\n}\n\n.text-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.self-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n\n  tr {\n    height: 40px;\n  }\n\n  td,\n  th {\n    border: 1px solid var(--line-color-level1);\n    padding: 10px;\n    text-align: left;\n    color: #262626;\n    font-weight: normal;\n  }\n\n  thead {\n    th {\n      background: var(--bg-info-color);\n    }\n  }\n}\n\n.center {\n  text-align: center !important;\n}\n\n.pb60 {\n  padding-bottom: 60px !important;\n}\n\n.color-common {\n  color: var(--color-primary);\n}\n\n.dataEl {\n  padding: 0 5px;\n  background-color: rgb(240, 250, 255);\n  border: 1px solid rgb(171, 220, 255);\n  border-radius: 4px;\n  height: 30px;\n  line-height: 30px;\n  width: 100%;\n  box-sizing: border-box;\n  color: rgb(46, 140, 240);\n\n  span {\n    max-width: 160px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .deleteIcon {\n    line-height: 30px;\n    cursor: pointer;\n  }\n}\n\n.add-sec {\n  width: 100%;\n  line-height: 30px;\n  color: var(--color-primary);\n  background-color: rgb(249, 250, 252);\n  border: 1px solid #ebeef5;\n  padding: 5px 20px 5px 30px;\n  cursor: pointer;\n}\n\n.un-select-control {\n\n  .el-drawer,\n  * {\n    user-select: none;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.number-color {\n  color: var(--color-primary)\n}\n\n.text_danger {\n  color: var(--color-danger);\n  font-weight: normal;\n  font-size: 12px;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.el-dialog__wrapper .el-dialog .el-dialog__body .el-form-item--mini .el-form-item {\n  margin-right: inherit;\n}\n\n.el-dialog__wrapper .el-dialog .el-dialog__body .el-form--inline .el-form-item--mini .el-form-item {\n  //margin-right: 23px;\n}\n\n.el-popper {\n  .el-cascader-node__label {\n    max-width: 300px;\n  }\n\n  .el-select-dropdown__item {\n    //max-width: 700px;\n  }\n}\n\n.height-auto {\n  height: 100%;\n}\n\n.tableSortHeader {\n  display: flex;\n\n  .arrow_box {\n    justify-content: center;\n    height: 14px;\n    width: 14px;\n    margin-left: 5px;\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    overflow: initial;\n\n    .top {\n      width: 0;\n      height: 0;\n      border: 4px solid transparent;\n      left: 7px;\n      border-bottom-color: #c0c4cc;\n      margin-bottom: 3px;\n    }\n\n    .top:hover {\n      border-bottom-color: var(--color-primary);\n    }\n\n    .bottom {\n      width: 0;\n      height: 0;\n      border: 4px solid transparent;\n      left: 7px;\n      border-top-color: #c0c4cc;\n    }\n\n    .bottom:hover {\n      border-top-color: var(--color-primary);\n    }\n  }\n}\n\n.isActiveTop {\n  border-radius: 2px;\n  border-bottom-color: var(--color-primary) !important;\n}\n\n.isActiveBottom {\n  border-radius: 2px;\n  border-top-color: var(--color-primary) !important;\n}\n\n.el-step__head.is-success {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.el-step__description.is-success,\n.el-step__title.is-success {\n  color: var(--color-primary);\n}\n\n.el-loading-mask.is-fullscreen {\n  z-index: 3000 !important;\n}\n\n.question-icon {\n  color: var(--color-primary);\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.common-divider {\n  margin: 6px 0;\n}\n\n.dashboard-designer .el-table__empty-block {\n  position: relative;\n  min-height: 164px;\n  width: 100% !important;\n  border-bottom: 1px solid #ebeef5;\n\n  &:before {\n    content: '';\n    display: block;\n    width: 184px;\n    height: 102px;\n    position: absolute;\n    background-image: url('../img/empty.png');\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    top: 20px;\n    left: calc(50% - 92px);\n  }\n\n  &:after {\n    position: absolute;\n    content: '';\n    height: 4px;\n    width: 100%;\n    bottom: 0;\n    background: #fff;\n    z-index: 99;\n  }\n\n  .el-table__empty-text {\n    position: absolute;\n    top: 122px;\n    line-height: 22px;\n    color: var(--text-color-level4);\n  }\n}\n\n.dashboard-designer .el-empty {\n  .el-empty__description {\n    margin-top: 0px;\n    line-height: 20px;\n  }\n\n  .el-empty__bottom {\n    margin-top: 4px;\n    line-height: 20px;\n  }\n}\n\n// .el-tooltip__popper.is-dark {\n//   background-color: var(--color-text-primary);\n//   max-width: 500px;\n// }\n\n// .el-tooltip__popper .el-popper[x-placement^='bottom'] .popper__arrow::after {\n//   border-bottom-color: #595959 !important;\n// }\n\n// .el-tooltip__popper .el-popper[x-placement^='top'] .popper__arrow::after {\n//   border-top-color: #595959 !important;\n// }\n\n// .el-tooltip__popper.is-dark[x-placement^='bottom'] .popper__arrow::after {\n//   border-bottom-color: var(--color-text-primary) !important;\n// }\n\n// .el-tooltip__popper.is-dark[x-placement^='top'] .popper__arrow::after {\n//   border-top-color: var(--color-text-primary) !important;\n// }\n\n*[w-title] {\n  position: relative;\n}\n\n*[w-title]:after {\n  content: attr(w-title);\n  position: absolute;\n  width: 160px;\n  top: 20px;\n  left: 0;\n  z-index: 9999;\n  background: #ffffff;\n  padding: 4px 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0px 0px 6px rgba(0, 0, 0, 0.04);\n  border-radius: 2px;\n}\n\n.sticky-select .el-select-dropdown,\n.sticky-select .el-date-picker {\n  position: absolute !important;\n  top: 30px !important;\n  left: 0 !important;\n}\n\n.layout-offset-button {\n  position: absolute;\n  right: 1%;\n  transform: translateY(51px);\n}\n\n.tabs_box {\n  // border-bottom: 1px solid #EBEEF5;\n  overflow-y: hidden;\n}\n\n//.el-form-item .el-input,.el-form-item .el-select,.el-form-item .el-cascader{\n//  width: 180px;\n//}\n//\n//.el-form-item .el-select .el-input{\n//  width: 100%\n//}\n//.el-form-item .el-cascader .el-input{\n//  width: 100%\n//}\n//.el-form-item .el-input-number .el-input{\n//  width: 100%\n//}\n\n.cell .table-cell-flex {\n  display: flex;\n}\n\n.cell .table-cell-flex>div:first-child,\n.cell .table-cell-flex>span:first-child {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.item-divider {\n  width: 3px;\n  height: 12px;\n  margin-right: 4px;\n  background: var(--color-primary);\n}\n\n.g6-grid-container {\n  z-index: 10;\n}\n\n.dashboard-designer .el-checkbox__label {\n  padding-left: 6px;\n}\n\n.dashboard-designer .el-checkbox {\n  color: var(--color-text-primary);\n}\n\n.el-select-dropdown__list {\n  .my-input-search {\n    padding: 0 10px;\n  }\n}\n\n.el-select-dropdown__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@media screen and (max-height: 768px) {\n  .layui-dialog-warp .el-dialog__body {\n    max-height: none !important;\n  }\n}\n\n.dashboard-designer .layui-dialog-warp {\n  .el-dialog__body {\n    //max-height: none !important;\n  }\n\n  .el-dialog__footer {\n    border-top: none;\n    padding: 0;\n  }\n}\n\n.dashboard-designer .el-cascader__suggestion-list {\n  .hover {\n    background-color: #f5f7fa;\n  }\n}\n\n\n.dashboard-designer .el-table th.table-header-gray {\n  background-color: var(--bg-info-color);\n  color: var(--color-text-regular);\n}\n\n.dashboard-designer .el-table--border th {\n  :not(:last-child):not(.el-checkbox__inner) {\n    &:after {\n      content: \"\";\n      display: none;\n      width: 1px;\n      height: 16px;\n      position: absolute;\n      background: #dfe2e8;\n      right: 0;\n      top: 5px;\n    }\n  }\n}\n\n.dashboard-designer .el-table--border th.is-leaf .cell {\n  &:after {\n    content: \"\";\n    display: block;\n    width: 1px;\n    height: 16px;\n    position: absolute;\n    background: #dfe2e8;\n    right: 0;\n    top: 5px;\n  }\n}\n\n.dashboard-designer .el-table th:nth-last-child(2) .cell {\n  &:after {\n    display: none;\n  }\n}\n\n.dashboard-designer .el-table th:last-child .cell {\n  &:after {\n    display: none;\n  }\n}\n\n.dashboard-designer .el-table-column--selection .cell {\n  &:after {\n    display: none !important;\n  }\n}\n\n.dashboard-designer .el-table td,\n.dashboard-designer .el-table th.is-leaf {\n  border-color: transparent;\n}\n\n.dashboard-designer .el-table--border .el-table__cell {\n  border-right: none;\n  color: var(--text-color-level6);\n}\n\n.dashboard-designer .el-table--border,\n.dashboard-designer .el-table--group {\n  border: none;\n}\n\n.el-message {\n  z-index: 99999 !important;\n  padding: 10px 20px 10px 10px !important;\n}\n\n.el-message__closeBtn {\n  right: 5px;\n}\n\n.el-message__content {\n  padding-right: 25px !important;\n}\n\n.el-tag.render-tag-warp {\n  border-color: transparent;\n}\n\n.text-overflow-hidden {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  white-space: normal;\n}\n\n.el-scrollbar {\n  width: 100%;\n}\n\n.el-button--small+.el-button--small {\n  margin-left: 12px;\n}\n\n.el-message-box__btns .el-button--small {\n  padding: var(--padding-gap-mini) var(--block-gap-primary);\n  font-size: 12px;\n}\n\n.el-dialog__footer .el-button--mini+.el-button--mini {\n  margin-left: 12px;\n}\n\n.info-toast-custom {\n  .el-icon-info {\n    font-size: 14px !important;\n    margin-top: -26px !important;\n  }\n}\n\n.custom-alert-info-detail {\n  background-color: rgba(239, 247, 255, 1);\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  color: var(--text-color-level6);\n\n  .tip-title {\n    font-size: 12px;\n    line-height: 20px;\n  }\n\n  .tip-icon {\n    font-size: 16px;\n    color: var(--color-primary);\n    margin-right: 6px;\n    line-height: 20px;\n  }\n}\n\n.disable_maker {\n  width: 6px;\n  height: 6px;\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 6px;\n  background: var(--text-color-level4);\n}\n\n.enable_maker {\n  width: 6px;\n  height: 6px;\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 6px;\n  background: var(--color-success);\n}\n\n.custom-alert-info-detail {\n  background-color: rgba(239, 247, 255, 1);\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  color: var(--text-color-level6);\n\n  .tip-title {\n    font-size: 12px;\n    line-height: 20px;\n  }\n\n  .tip-icon {\n    font-size: 16px;\n    color: var(--color-primary);\n    margin-right: 6px;\n    line-height: 20px;\n  }\n}\n\n.no-footer-dialog .el-dialog__footer {\n  display: none;\n}\n\n\n.icon-sec {\n  width: 60px;\n  cursor: pointer;\n  z-index: 9;\n  top: 67px;\n  display: flex;\n  margin-right: 6px;\n\n  .icon-sec-left,\n  .icon-sec-right {\n    width: 30px;\n    height: 28px;\n    border: 1px solid #f0f0f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .icon-sec-left {\n    border-radius: 4px 0px 0px 4px;\n  }\n\n  .icon-sec-right {\n    border-radius: 0px 4px 4px 0px;\n  }\n\n  .icon {\n    font-size: 18px;\n    line-height: 28px;\n    color: rgb(219, 219, 219);\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  .active {\n    color: rgb(50, 152, 255);\n  }\n\n  .active-div {\n    background: rgba(62, 123, 250, 0.1);\n    border: 1px solid var(--color-primary);\n  }\n}\n\n.el-select-dropdown.el-popper.rule-config-popper {\n  display: none;\n}\n\ninput {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.customKnowMessage .el-icon-close:before {\n  content: '我知道了';\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--color-primary)\n}\n\n.customKnowMessage .el-message__content {\n  padding-right: 50px !important\n}\n\n.el-message {\n  max-width: 60%;\n  max-height: 40%;\n  word-break: break-all;\n  overflow-y: auto;\n}\n\n.el-notification.centerNotify.right {\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 420px;\n}\n\n.centerNotify .el-notification__title {\n  font-size: 14px;\n  color: #1d2129;\n  line-height: 22px;\n}\n\n.centerNotify .el-notification__content {\n  font-size: 12px;\n  color: #4e5969;\n  line-height: 20px;\n}\n\n.centerNotify .el-notification__icon {\n  height: 14px;\n  width: 14px;\n  font-size: 16px;\n  line-height: 22px;\n}\n\n.centerNotify .el-notification__group {\n  margin-left: 8px;\n}\n\n\n.svgIcon {\n  width: 24px;\n  height: 24px;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n\n.vnode-radio .el-radio__label {\n  display: none\n}\n\n.db-form-item .el-form-item__label {\n  line-height: 1.2;\n}\n\n.jzliu-bi-engine-export-prompt {\n  .el-message-box__content {\n    display: flex;\n    align-items: center;\n  }\n\n  .el-message-box__container {\n    margin-right: 12px;\n  }\n\n  .el-message-box__input {\n    flex: 1\n  }\n\n  .el-button--small {\n    padding: 9px 15px !important;\n    font-size: 12px !important;\n    border-radius: 3px;\n  }\n}","/*fade*/\n.cdsp_dashboard .fade-enter-active,\n.cdsp_dashboard .fade-leave-active {\n  transition: opacity 0.28s;\n}\n\n.cdsp_dashboard .fade-enter,\n.cdsp_dashboard .fade-leave-active {\n  opacity: 0;\n}\n\n/*fade*/\n.cdsp_dashboard .breadcrumb-enter-active,\n.cdsp_dashboard .breadcrumb-leave-active {\n  transition: all 0.5s;\n}\n\n.cdsp_dashboard .breadcrumb-enter,\n.cdsp_dashboard .breadcrumb-leave-active {\n  opacity: 0;\n  transform: translateX(20px);\n}\n\n.cdsp_dashboard .breadcrumb-move {\n  transition: all 0.5s;\n}\n\n.cdsp_dashboard .breadcrumb-leave-active {\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
